import React, { useEffect, useState } from "react";
import CustomCard from "../../../../components/custom-card/custom-card";
import GradientButton from "../../../../components/gradient-tick-button/gradient-tick-button";
import CustomPieChart from "../../../../components/custom-piechart/custom-piechart";
import styles from "./staff-attendance.module.css";
import { getTeacherAttendanceData } from "../../../../services/dashboard";

const COLOUR_MAP = {
  "Present Today": "#77F374",
  "Absent Today": "#EDE415",
  "On Leave": "#7FD6FB",
};

const StaffAttendanceCard = () => {
  const [attendanceDetails, setAttendanceDetails] = useState([]);
  const [attendanceRate, setAttendanceRate] = useState("");
  const [totalStudent, setTotalStudent] = useState("");
  const [presentCount, setPresentCount] = useState(0);

  useEffect(() => {
    fetchTeacherAttendance();
  }, []);

  const fetchTeacherAttendance = async () => {
    try {
      const response = await getTeacherAttendanceData();
      if (response?.data) {
        const responceData = response?.data?.data;
        setAttendanceDetails(responceData?.attendanceDetails);
        setAttendanceRate(responceData?.attendance_rate);
        setTotalStudent(responceData?.total);

        const presentEntry = responceData?.attendanceDetails.find(
          (entry) => entry.attendance === "Present Today"
        );
        setPresentCount(Number(presentEntry?.student_count || 0));
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const processedData = attendanceDetails.map((item) => ({
    name: item.attendance,
    percentage: item.percentage,
    count: item.student_count,
    colour_code: COLOUR_MAP[item.attendance] || "#CCCCCC",
  }));

  return (
    <CustomCard className={styles.attendanceCard}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          columnGap: 7,
        }}
      >
        <div className={styles.card_container}>
          <span className={styles.card_heading}>
            Today’s Attendance ({presentCount}/{totalStudent})
          </span>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <GradientButton />
        </div>
      </div>

      <div className={styles.chartStatsWrapper}>
        <CustomPieChart
          data={processedData}
          labelText="Attendance Rate"
          labelValue={attendanceRate}
        />

        <div className={styles.statsList}>
          {processedData.map((entry, idx) => {
            return (
              <div key={idx} className={styles.statsItem}>
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: entry.colour_code,
                  }}
                />
                <span>{entry.name}</span>
                <span className={styles.countValue}>{entry.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </CustomCard>
  );
};

export default StaffAttendanceCard;
